export default __webpack_public_path__ + "static/blueprint-graphic-160defb22ffce9609d59bb9b607315ea.png";